import { render, staticRenderFns } from "./CustomPage.vue?vue&type=template&id=4bcc41b4&scoped=true"
import script from "./CustomPage.vue?vue&type=script&lang=js"
export * from "./CustomPage.vue?vue&type=script&lang=js"
import style0 from "./CustomPage.vue?vue&type=style&index=0&id=4bcc41b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcc41b4",
  null
  
)

export default component.exports